import React from 'react';
import DefaultThumb from '.';

const Default = () => (
    <DefaultThumb>
        <svg width="20" height="27" viewBox="0 0 20 27" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M19.2656 5.10417L14.8958 0.734375C14.4271 0.265625 13.7917 0 13.1302 0H2.5C1.11979 0.00520833 0 1.125 0 2.50521V24.1719C0 25.5521 1.11979 26.6719 2.5 26.6719H17.5C18.8802 26.6719 20 25.5521 20 24.1719V6.875C20 6.21354 19.7344 5.57292 19.2656 5.10417ZM18.0885 6.28646C18.1979 6.39583 18.2708 6.52604 18.3073 6.67188H13.3333V1.69792C13.4792 1.73437 13.6094 1.80729 13.7187 1.91667L18.0885 6.28646ZM17.5 25.0052H2.5C2.04167 25.0052 1.66667 24.6302 1.66667 24.1719V2.50521C1.66667 2.04688 2.04167 1.67187 2.5 1.67187H11.6667V7.08854C11.6667 7.78125 12.224 8.33854 12.9167 8.33854H18.3333V24.1719C18.3333 24.6302 17.9583 25.0052 17.5 25.0052Z" fill="#A2A4AA"/>
        </svg>
    </DefaultThumb>
);

export default Default;
